<template>
  <li class="dropdown-item">
    <template v-if="multiple && (!level || isAboveLevel)">
      <checkbox-empty v-if="!isSelected" />
      <checkbox-selected v-if="isSelected" />
    </template>

    <span
      v-if="!labelPrefix"
      :class="{indented: multiple && level && !isAboveLevel}">{{ optionTitle }}
    </span>
    <span
      v-if="labelPrefix"
      :class="{indented: multiple && level && !isAboveLevel}">
      {{ labelPrefix }}
      <chevron-right />
      {{ optionTitle }}
    </span>
    <span
      v-if="actionText"
      class="secondary">{{ actionText }}
    </span>
  </li>
</template>

<script>
import CheckboxEmpty from '../../assets/icons/checkbox-empty.svg?inline'
import CheckboxSelected from '../../assets/icons/checkbox-selected.svg?inline'
import ChevronRight from '../../assets/icons/chevron-right.svg?inline'

export default {
  name: 'a-select-dropdown-item',
  components: {
    CheckboxEmpty,
    CheckboxSelected,
    ChevronRight,
  },
  props: {
    level: {
      type: String,
      required: true,
    },
    cohort: {
      type: String,
      required: true,
    },
    isAboveLevel: {
      type: Boolean,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
    optionTitle: {
      type: String,
      required: true,
    },
    labelPrefix: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isSubscriber() {
      return this.cohort === 'basic' || this.cohort === 'advanced'
    },
    actionText() {
      if (this.isAboveLevel) { return '' }
      if (this.level === 'registered') { return 'register' }
      if (!this.isSubscriber && (this.level === 'basic' || this.level === 'advanced')) { return 'advanced' }
      if (this.isSubscriber && this.level === 'advanced') { return 'upgrade' }
      return ''
    },
  },
}
</script>

<style scoped>
.dropdown-item {
  display: flex;
}
.dropdown-item svg {
  height: 20px;
  width: 20px;
  margin-right: 3px;
}
.highlight .secondary {
  color: #5fa5d9;
}
.secondary {
  color: #ccc;
  float: right;
  font-weight: normal;
  position: absolute;
  right: .5em;
  text-decoration: none;
}
.secondary:focus, .secondary:hover {
  color: #428bca;
}
.secondary svg {
  fill: #ccc;
}
.indented {
  padding-left: 1.5em;
}
</style>
